import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetHealthDistricts,
	GetHealthDistrictsModel,
	GetHealthDistrictsParams,
} from 'domain/usecases/private/booking-flow/health/get-health-districts';

export class RemoteGetHealthDistricts implements GetHealthDistricts {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthDistrictsModel>,
	) {}

	async get({signal, ...params}: GetHealthDistrictsParams): Promise<GetHealthDistrictsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
